import React from 'react';

class FieldText extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: '',
        };

        this._onChange = this._onChange.bind(this);
    }

    _onChange(event) {
        this.setState({value: event.target.value});
    }

    render() {
        const {item} = this.props;
        const autofocus = (item.id === "1");

        const req = (item.req === "Y") ? "_req" : "";
        const required_sign = (item.req === "Y") ? <sup>*</sup> : '';

        const filled = (this.state.value)? 'is-not-empty' :'';

        return (
            <div className="order-props__prop-item">
                <div className="form-control">
                    <input type="text"
                           defaultValue=""
                           name={item.property_id}
                           id={item.property_id}
                           className={req + ' '+ filled}
                           autoFocus={autofocus}
                           onChange={this._onChange}
                    />
                    <label htmlFor={item.property_id}>{item.name} {required_sign}</label>
                </div>
            </div>
        );
    }
}

export default FieldText